import { CloseOutlined, PrinterOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Form, Input, message, Space, Select, Tabs } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { dictsReportVids } from "../../../extensions/dicts";
import ReportBodyEditor from "./report-body-editor";
import "./report-designs.css";

const { TabPane } = Tabs;

const ReportDesign = ({ id, onClose }) => {
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [form] = Form.useForm();

  const parseBody = (body) => {
    if (!body) return [];
    try {
      return typeof body === 'string' ? JSON.parse(body) : body;
    } catch (e) {
      console.error("Ошибка парсинга body:", e);
      message.warning("Ошибка при загрузке элементов отчета");
      return [];
    }
  };

  const getData = () => {
    if (id === 0) {
      const newItem = { id: 0, name: "", description: "", vid: 1, companyId: null, body: [] };
      setItem(newItem);
      form.setFieldsValue(newItem);
    }
    else {
      setLoading(true);
      serverFetch(`reportdesign/${id}`)
        .then(data => {
          const itemWithParsedBody = { ...data, body: parseBody(data.body) };
          setItem(itemWithParsedBody);
          form.setFieldsValue(itemWithParsedBody);
        })
        .catch(e => message.error(e.userMessage || "Ошибка загрузки данных"))
        .finally(() => setLoading(false));
    }
  };

  useEffect(getData, [id, form]);

  const onValuesChange = value => setItem({ ...item, ...value });

  const onSave = async (close) => {
    try {
      await form.validateFields();
      setLoading(true);      
      const itemToSave = { ...item, body: JSON.stringify(item.body || []) };
      await serverFetch("reportdesign", { 
        method: id === 0 ? "POST" : "PUT", 
        bodyData: itemToSave 
      });      
      message.success("Запись сохранена");
      close && onClose(true);
    } catch (e) {
      setLoading(false);
      if (e.errorFields) message.warning("Заполните обязательные поля");
    }
  };

  const onExport = () => {
    if (!item || !item.name) {
      message.warning("Нет данных для экспорта");
      return;
    }

    try {
      // Подготавливаем данные для экспорта
      const exportData = {
        ...item,
        body: item.body || [] // Убеждаемся что body это массив
      };

      // Создаем JSON строку с отступами для читаемости
      const jsonString = JSON.stringify(exportData, null, 2);
      
      // Создаем Blob с JSON данными
      const blob = new Blob([jsonString], { type: 'application/json' });
      
      // Создаем URL для скачивания
      const url = window.URL.createObjectURL(blob);
      
      // Создаем временную ссылку для скачивания
      const link = document.createElement('a');
      link.href = url;
      link.download = `${item.name}.json`;
      
      // Добавляем ссылку в DOM, кликаем и удаляем
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Освобождаем память
      window.URL.revokeObjectURL(url);
      
      message.success("Файл успешно экспортирован");
    } catch (error) {
      console.error("Ошибка экспорта:", error);
      message.error("Ошибка при экспорте файла");
    }
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay">
        <div className="sport-modal-content" style={{width: 1200}}>
          <div className="client-modal-title">
            <span>Шаблон отчета</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="custom-tabs-container">
            <Tabs activeKey={activeTab} onChange={setActiveTab} type="card" className="custom-tabs">
              <TabPane tab="Основная информация" key="1">
                {activeTab === "1" && (
                  <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false} disabled={loading} onValuesChange={onValuesChange}>
                    <Form.Item label="Наименование" name="name" rules={[{ required: true, message: "Обязательное поле" }]} >
                      <Input maxLength={200} />
                    </Form.Item>                    
                    <Form.Item label="Описание" name="description">
                      <Input.TextArea rows={3} maxLength={500} />
                    </Form.Item>
                    <Form.Item label="Вид" name="vid" rules={[{ required: true, message: "Обязательное поле" }]}>
                      <Select options={dictsReportVids} style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label=" ">
                      <Space>
                        <Button type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
                        <Button icon={<DownloadOutlined />} onClick={onExport} disabled={!item?.name}>
                          Экспорт
                        </Button>
                        <Button onClick={() => onClose(false)}>Закрыть</Button>
                      </Space>
                    </Form.Item>
                  </Form>
                )}
              </TabPane>
              <TabPane tab="Элементы отчета" key="2">
                {activeTab === "2" && (
                  <ReportBodyEditor value={item?.body || []} 
                    onChange={(body) => { setItem({ ...item, body }); form.setFieldsValue({ body }); }} 
                    disabled={loading} 
                    onSaveMain={onSave}
                    />
                )}
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportDesign;